var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#variant-2_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "variant-2_svg__tetris-dark-path",
    fill: "#7A4FF3",
    d: "M100 100h100v200H100V100z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#variant-2_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "variant-2_svg__tetris-light-path",
    fill: "#956FFF",
    d: "M100 0h100v100H100V0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "variant-2_svg__tetris-light-path",
    fill: "#956FFF",
    d: "M0 100h100v100H0V100z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "variant-2_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v300H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "variant-2_svg__filter0_d",
    width: 140,
    height: 140,
    x: 84,
    y: -12,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant2);
export default "/_next/static/images/32470bdd919fbdbdcc5595a2b2550782.svg";
export { ForwardRef as ReactComponent };